import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyAndLoadUser = async () => {
            setLoading(true);
            try {
                const storedUser = localStorage.getItem('user');
                if (storedUser) {
                    const parsedUser = JSON.parse(storedUser);
                    // Vérifier la session avec le backend
                    const response = await fetch('https://venteclead.st-info.fr/verify_session.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ user_id: parsedUser.id }),
                    });
                    const data = await response.json();

                    if (data.valid) {
                        setUser(parsedUser);
                    } else {
                        // Session invalide, déconnecter l'utilisateur
                        localStorage.removeItem('user');
                        setUser(null);
                        console.warn("Session invalide. Utilisateur déconnecté.");
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la vérification/lecture de session", error);
                localStorage.removeItem('user');
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        verifyAndLoadUser();
    }, []); // Les dépendances sont vides car cette vérification se fait une seule fois au montage

    const login = async (email, password) => {
        const response = await fetch('https://venteclead.st-info.fr/login.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });
        const data = await response.json();

        if (data.success) {
            // Assurez-vous que l'objet user contient id et role
            setUser({ id: data.user.id, email: data.user.email, nom: data.user.nom, role: data.user.role });
            localStorage.setItem('user', JSON.stringify({ id: data.user.id, email: data.user.email, nom: data.user.nom, role: data.user.role }));
            return { success: true };
        } else {
            return { success: false, message: data.message };
        }
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
    };

    const value = {
        user,
        isAuthenticated: !!user,
        loading,
        login,
        logout,
        isAdmin: user?.role === 'Administrateur',
        isFournisseur: user?.role === 'Fournisseur',
    };

    // Ne pas rendre l'application tant que le statut d'authentification n'est pas vérifié
    if (loading) {
        return <div className="flex justify-center items-center h-screen">Chargement...</div>;
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
}; 